import { FC } from 'react';
import { Route, Routes } from 'react-router-dom';
import { General } from '../components/Settings';

const SettingsRouter: FC = () => (
    <Routes>
        <Route path="/general" element={<General />} />
    </Routes>
);

export { SettingsRouter };
